import { InvestmentFormValues } from "./types";

const slugSpecificDefaults: Record<string, Partial<InvestmentFormValues>> = {
  real_estate: {
    propertyType: "",
    propertyTypeOther: "",
    area: "",
    city: "",
    address: "",
  },
  precious_stones: {
    mass: "",
    cut: "",
    color: "",
    clarity: "",
  },
  precious_metals: {
    propertyType: "",
    mass: "",
    fineness: "",
  },
  treasury_bonds: {
    interestType: "",
    interestRate: "",
  },
  artwork: {
    author: "",
    eraAge:"",
    artworkType: "",
    unknownAuthor: false,
  },
  investment_policy: {
    contractDate: "",
    premiumPayment: "",
    durationDate: "",
    durationDateValue: "",
  },
  loans: {
    autoRenewal: "",
    loanType: "borrowed",
    entity: "",
    interestPayment: "",
    interestRate: "",
    durationDate: "",
    durationDateValue: "",
  },
};

export const getInitialValues = (
  slug: string,
  defaults?: Partial<InvestmentFormValues>,
): InvestmentFormValues => {
  return {
    investmentTypeSlug: slug,
    name: "",
    primaryValue: "",
    currencyUuid: "",
    quantity: "",
    purchaseRate: "",
    additionalInfo: "",
    relianceCanView: false,
    contractFile: null,
    photoFiles: null,
    ...(slugSpecificDefaults[slug] || {}),
    ...defaults,
  };
};
